/** Default page size for operations history. */
export const OPERATIONS_PAGE_SIZE = 25;

/** Polling interval for active operations in milliseconds. */
export const OPERATION_POLL_INTERVAL = 5_000;
